import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

// material ui
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'

// atomic components/containers
import Loading from 'components/atoms/Loading'
import ErrorMessage from 'components/shared/ErrorMessage'

// shared components
import RegistrationStep from 'components/register/shared/RegistrationStep'

// helpers
import { PAYMENT_STEP } from 'lib/helpers/registration/navigation'

// local components
import CartEmpty from './CartEmpty'
import Checkout from './Checkout'

const Confirm = props => {
  const {
    loading,
    account, // via withQuery
    cartForm
  } = props

  // the banner reports a declined payment, so offer the same way out as the button below
  const { paymentMethodHelpText } = account?.registrationStatus || {}

  return (
    <RegistrationStep>
      <ErrorMessage>
        {paymentMethodHelpText && (
          <Box mt={2}>
            <Link
              component={RouterLink}
              to={PAYMENT_STEP.path}
              color='inherit'
              underline='always'
            >
              Enter a new payment method
            </Link>
          </Box>
        )}
      </ErrorMessage>
      {!account || loading ? (
        <Loading />
      ) : !cartForm ? (
        <CartEmpty />
      ) : (
        <Checkout {...props} />
      )}
    </RegistrationStep>
  )
}

export default Confirm
